export enum AppRoles {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Member = 'Member',
  NoAccess = 'NoAccess',
  DamageApprover = 'DamageLineApprover',
  LoadAdmin = 'LoadAdmin',
  MechanicalAdmin = 'CanMechanicalUpdate',
}
